/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { UserState } from "../state/user-state";
import { NotificationService } from "../core/services/notification.service";
import { PreloaderService } from "../core/services/preloader.service";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { DialogService } from "../core/services/dialog.service";
import * as ButtonSelectionActions from "../state/actions/button-click.actions";
import { Subject, takeUntil } from "rxjs";
import { HeaderService } from "../core/services/header.service";
import { ROUTES } from "../core/constants/routes";

@Component({
  selector: "app-dashboard",
  styleUrls: ["./default-layout.component.scss"],
  templateUrl: "./default-layout.component.html",
})

export class DefaultLayoutComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject<void>();

  constructor(private store: Store<UserState>,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private router: Router,
    protected prelaodService: PreloaderService,
    protected headerService: HeaderService) {

    this.notificationService.connectToSignalR();
  }

  ngOnInit(): void {
    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.dialogService.closeDialog();
        }
        if (event instanceof NavigationEnd) {
          this.dialogService.checkIfUserHasExpiringMBC();
          this.selectHeaderButtons();
        }
      });
  }
  selectHeaderButtons() {
    let currentRoute = this.headerService.decodeUrl(this.router.url);
    if (this.headerService.isTabComponentVisible()) {
      const selectedModule = (currentRoute == ROUTES.TRANSACTION_HISTORY || currentRoute == ROUTES.HOME_CAFE) ? ROUTES.HOME_CAFE : ROUTES.HOME_BETTING;
      this.store.dispatch(ButtonSelectionActions.STATUS_BAR_MODULE_SELECTED({ button: selectedModule }));
    }
    if (this.headerService.isBettingTabActive()) {
      this.store.dispatch(ButtonSelectionActions.BETTING_TAB_SELECTED({ button: currentRoute }));
    }
  }

  getAdditionalMargin(): string {
    if (this.headerService.isBettingTasksTabsVisible()) {
      return "additionalMargin-betting";
    }
    if (this.headerService.isHistoryTabsVisible()) {
      return "additionalMargin-transactions";
    }
    if (this.headerService.isAboutPageVisible()) {
      return "additionalMargin-about";
    }
    if (this.headerService.isNavigationVisible()) {
      return "additionalMargin-profile";
    }
    if (this.headerService.isJackpotTabsVisible()) {
      return "additionalMargin-jackpot";
    }
    return "additionalMargin";
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}